import React from 'react'
import data from '../data'
import { FaDownload  } from 'react-icons/fa';

function StickersPage() {
  return (

    <>
    <div className='flex-left'>
        <h3 ><a href='/faq'>Intrebari frecvente</a></h3>
    </div>

    <div className='flex-container'>
      
<div className="container " >
  <div className="row ">
  {data.map(({ img, uri, key }) => (
  <div className='col-sm ' style={{marginTop:15}}>
            
            <div 
            key={key}
            style={{
              backgroundImage:`url(${img})`,
              width:200, 
              height:200,
              backgroundSize: 'cover',
              backgroundRepeat:'no-repeat', 
              backgroundPosition: 'center',
              boxShadow: 'inset 0 0 0 1000px rgba(0,0,0,.2)',
            
              border: 'solid 0.1px #c60000',
              }}
      
            
              >
               
              {/* <a href='./156.pdf' download style={{display: 'flex', justifyContent: 'center', alignItems:'center'}} > */}
              <a href={uri.uri} download style={{display: 'flex', justifyContent: 'center', alignItems:'center'}} >
              
                <FaDownload icon={FaDownload} style={{color: 'rgba(255, 255, 255, 0.9)',marginTop:"73%",marginLeft:"60%"}} size={45}/>      
              </a>    
              
            </div>                    
          
  </div>
          ))}
  </div>
</div>

    </div>
    </>
  )
}

export default StickersPage